module.exports = __webpack_public_path__ + "static/media/android_logo_white.86d1fa3e.svg";